import { render } from "./Coin_Indicator.vue?vue&type=template&id=b7d86690"
import script from "./Coin_Indicator.vue?vue&type=script&lang=js"
export * from "./Coin_Indicator.vue?vue&type=script&lang=js"

import "./Coin_Indicator.vue?vue&type=style&index=0&id=b7d86690&lang=css"
script.render = render

export default script